import { Modal } from "react-bootstrap";
import ProductComboListModalProduct from "./ProductComboListModalProduct";

export default function ListModalBody(props) {
    
    const products = props.productComboChildDetails.productList.productComboProductList.map(item => {
        return (
            <ProductComboListModalProduct
                key={item.productId}
                data={item}
                handleSelectProductInComboList={props.handleSelectProductInComboList}
            />
        )
    });
    
    return (
        <Modal.Body className="wo-loy__body">
            <div className="wo-vprod__list">
                {products}
            </div>
        </Modal.Body>
    )
}